import { env } from '@packages/runtime-config';
import axios, { type AxiosInstance } from 'axios';
import { bindInterceptors, defaultAxiosParams } from './default';
import { getHandleAxiosError } from './helpers';

export abstract class BaseApi {
  protected instance: AxiosInstance;

  constructor() {
    // Всегда используем правильный домен, независимо от поддомена

    if (typeof window === 'undefined') {
      this.instance = axios.create({
        ...defaultAxiosParams,
        baseURL: env.API_URL || '/api/',
      });
      return;
    }

    this.instance = axios.create({
      ...defaultAxiosParams,
      baseURL: env.API_URL || '/api/',
    });

    bindInterceptors(this.instance, getHandleAxiosError(this.instance));
  }
}
